// const axios = require('axios');

export default {
    name : 'wcRest',

    init()
    {
        this.run();
    },

    run ()
    {
        const elements = document.querySelectorAll('.addToCartBtn');
        // _log(elements.length);

        if (typeof elements === 'object' && elements.length) {
            elements.forEach((el) => {
                    el.addEventListener('click', this.addToCart);
                }
            );
        }
    },

    addToCart__callbackSuccess ()
    {
        window['header'].updateCart();
    },

    defaultErrorCallback(error)
    {
        _log("defaultErrorCallback");
        _log(error);
        _log(error.response.data.message);
    },

    getConfig()
    {
        const config = {
            headers: {
                'X-WC-Store-API-Nonce' : document.getElementById('wpnonce').content,
            }
        };

        return config;
    },

    addToCart (produtId, qty, callback, callback_error)
    {
        _log('wcRest::addToCart');

        if (parseInt(produtId) === 'NaN') {
            _log('invalid produtId');
            return false;
        }

        const args = {
            id : produtId,
            quantity : qty ? parseInt(qty) : 1,
        };

        const catchMethod = (typeof callback_error === 'undefined') ?
                            this.defaultErrorCallback :
                            callback_error;

        _log(args);
        axios.post('/wp-json/wc/store/cart/add-item', args, this.getConfig())
            .then(callback)
            .catch(catchMethod);
    },


    getCartItems(callback, callback_error)
    {
        const catchMethod = (typeof callback_error === 'undefined') ?
                            this.defaultErrorCallback :
                            callback_error;

        axios.get('/wp-json/wc/store/cart/items', {}, this.getConfig())
            .then(callback)
            .catch(catchMethod);
    },

    getCart(callback, callback_error)
    {
        const catchMethod = (typeof callback_error === 'undefined') ?
                            this.defaultErrorCallback :
                            callback_error;

        axios.get('/wp-json/wc/store/cart', {}, this.getConfig())
            .then(callback)
            .catch(catchMethod);
    },




}